import './index.scss'
$(".faq ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text .answer").slideToggle();
})